import * as yup from "yup";

const GENDER_OPTIONS = ["Male", "Female", "Other"] as const;

export const personalDetailsSchema = yup
  .object({
    firstName: yup
      .string()
      .trim()
      .required("First name is required")
      .min(2, "First name must be at least 2 characters"),
    middleName: yup.string().trim(),
    lastName: yup
      .string()
      .trim()
      .required("Last name is required")
      .min(2, "Last name must be at least 2 characters"),
    dateOfBirth: yup
      .string()
      .required("Date of birth is required")
      .test("valid-date", "Please enter a valid date", (value) => {
        if (!value) return false;
        const date = new Date(value);
        return !isNaN(date.getTime());
      })
      .test("not-future", "Date of birth cannot be in the future", (value) => {
        if (!value) return false;
        return new Date(value) <= new Date();
      }),
    gender: yup
      .string()
      .required("Please select a gender")
      .oneOf(GENDER_OPTIONS, "Please select a gender"),
    isPlayer: yup.boolean().required(),
    isUmpire: yup.boolean().required(),
    isScorer: yup.boolean().required(),
  })
  .test({
    name: "at-least-one-role",
    test(value) {
      if (!value) return false;
      if (!(value.isPlayer || value.isUmpire || value.isScorer)) {
        return this.createError({
          path: "isPlayer",
          message: "Select at least one role",
        });
      }
      return true;
    },
  });

export type PersonalDetailsFormValues = yup.InferType<
  typeof personalDetailsSchema
>;
